import IconNext from "@/public_assets/icon_next.svg";
import IconArrows from "@/public_assets/instructions/arrows_keyboard.svg";
import IconBook from "@/public_assets/instructions/book.svg";
import IconMouseClick from "@/public_assets/instructions/mouse_click.svg";
import IconMouseWheel from "@/public_assets/instructions/mouse_wheel.svg";
import IconSpacebar from "@/public_assets/instructions/spacebar.svg";
import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import { IconTheme, TextIconButton } from "./IconButton/IconButton";
import styles from "./Instructions.module.scss";
import { LangSelection } from "./LangSelection";
import { WASDLayout } from "./atoms/WASDLayout";
import { CONFIG } from "@/config";
export function InstructionsContent() {
    var _a;
    return (React.createElement("div", { className: styles.controls },
        React.createElement("div", { className: styles.controlPanel },
            React.createElement("div", { className: styles.maxContent },
                React.createElement(FormattedMessage, { tagName: "div", id: "KS4oxD", defaultMessage: "Zoom on pages with your mousewheel" }),
                React.createElement(FormattedMessage, { tagName: "div", id: "Bu2gSw", defaultMessage: "Hold left mouse button and move with cursor" })),
            React.createElement("div", { className: styles.img },
                React.createElement(IconMouseWheel, null)),
            React.createElement("div", { className: styles.keyboard, style: { visibility: "hidden" } },
                React.createElement(FormattedMessage, { id: "u6nwhe", defaultMessage: "or press", tagName: "div" }),
                React.createElement(WASDLayout, null))),
        React.createElement("div", { className: styles.controlPanel },
            React.createElement("div", { className: styles.maxContent },
                React.createElement(FormattedMessage, { tagName: "div", id: "Bu2gSw", defaultMessage: "Hold left mouse button and move with cursor" }),
                React.createElement(FormattedMessage, { tagName: "div", id: "KS4oxD", defaultMessage: "Zoom on pages with your mousewheel" })),
            React.createElement("div", { className: styles.img },
                React.createElement(IconMouseClick, null)),
            React.createElement("div", { className: styles.keyboard },
                React.createElement(FormattedMessage, { id: "u6nwhe", defaultMessage: "or press", tagName: "div" }),
                React.createElement(WASDLayout, null))),
        React.createElement("div", { className: styles.controlPanel },
            React.createElement(FormattedMessage, { tagName: "div", id: "xM2w/j", defaultMessage: "Turn pages by clicking on them" }),
            React.createElement("div", { className: styles.img },
                React.createElement(IconBook, null)),
            React.createElement("div", { className: styles.keyboard },
                React.createElement(FormattedMessage, { id: "u6nwhe", defaultMessage: "or press", tagName: "div" }),
                React.createElement(IconArrows, null))),
        React.createElement("div", { className: styles.controlPanel },
            React.createElement(FormattedMessage, { tagName: "div", id: "HyqHUy", defaultMessage: "Control both music and ambiant volumes for a better experience" }),
            React.createElement("div", { className: styles.img },
                React.createElement("img", { src: require("@/public_assets/icon_sfx_white.png"), className: styles.soundSvg })),
            React.createElement("div", { className: styles.keyboard, style: {
                    visibility: (((_a = CONFIG.soundtrack) === null || _a === void 0 ? void 0 : _a.tracks) || []).length > 0
                        ? "visible"
                        : "hidden",
                } },
                React.createElement(FormattedMessage, { id: "uizmax", defaultMessage: "Press", tagName: "div" }),
                React.createElement(IconSpacebar, null),
                React.createElement(FormattedMessage, { id: "tkYVNw", defaultMessage: "to play/pause", tagName: "div" })))));
}
export function LoadingBlock(props) {
    var _a;
    return (React.createElement("div", { className: classNames(styles.bottom, styles.loadingBlock, (_a = {},
            _a[styles.loading] = props.loading,
            _a)) },
        props.loading && (React.createElement(React.Fragment, null,
            React.createElement(FormattedMessage, { id: "3HGZhn", defaultMessage: "Loading experience\u2026", tagName: "div" }),
            React.createElement("span", { className: styles.loader }))),
        !props.loading && (React.createElement(React.Fragment, null,
            React.createElement(FormattedMessage, { id: "s1Y8bQ", defaultMessage: "Click the \"Enter\" button when you're ready", tagName: "div" }),
            React.createElement(TextIconButton, { onClick: props.onEnter, theme: IconTheme.Dark },
                React.createElement(FormattedMessage, { id: "H8KGyc", defaultMessage: "Enter" }),
                React.createElement("img", { src: require("@/public_assets/icon_next.png"), style: { height: "20px" } }))))));
}
export function Instructions(_a) {
    var loading = _a.loading, onEnter = _a.onEnter;
    return (React.createElement("div", { className: styles.instructions },
        React.createElement(InstructionsContent, null),
        React.createElement(LoadingBlock, { loading: loading, onEnter: onEnter })));
}
export function InstructionsReminder() {
    return (React.createElement("div", { className: styles.instructions },
        React.createElement(InstructionsContent, null)));
}
export function InstructionsReminderWithLanguageSelector(props) {
    return (React.createElement("div", { className: styles.instructions },
        React.createElement("div", { className: styles.lang },
            React.createElement(LangSelection, null)),
        React.createElement(InstructionsContent, null),
        React.createElement("div", { className: styles.bottom },
            React.createElement(TextIconButton, { onClick: props.onClose, theme: IconTheme.Dark },
                React.createElement(FormattedMessage, { id: "rbrahO", defaultMessage: "Close" }),
                React.createElement(IconNext, null)))));
}
